// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3kq_N","title":"Images45_title__1bJuR","images":"Images45_images__3MZDZ"};